<template>
  <div style="max-width: fit-content">
    <v-tooltip left slot="activator" v-if="isAuthenticated">
      <v-btn slot="activator"
        @click.stop="openContactDialog"
        icon>
        <v-icon>help</v-icon>
      </v-btn>
      <span>{{$tf('Contact')}}</span>
    </v-tooltip>

    <v-menu class="notifications-menu"  offset-y
            v-if="isAuthenticated && !$store.state.nav.fullView && !$store.getters['session/isScoped']">
      <v-tooltip left slot="activator">
        <v-btn slot="activator"
               v-if="$store.state.config.notifications"
               @click.prevent="openNotifications()"
               icon>

          <v-badge color="warning" overlap>
            <span slot="badge" v-if="$store.getters['notifications/newNotifications'] && !isVisible ">
              {{$store.getters['notifications/newNotifications']}}
            </span>
            <v-icon>notifications</v-icon>
          </v-badge>

        </v-btn>
        <span>{{$tf('Notifications')}}</span>
      </v-tooltip>

      <v-spacer id="spaceList" style="min-width:250px; width:30vw;height: 10px;background-color: white;"></v-spacer>
      <div class="notifications-list" id="notifications-list" v-observe-visibility="refreshComponent">
        <v-list three-line v-if="!!$store.state.notifications.notifications.length">
          <template v-for="(notification, index) in notificationsList" >
            <v-list-tile class="single-notification"  avatar :class="{unread: !notification.read_at}" :key="index" v-if="notification.title"
                         @click="notification.payload.file_url || notification.payload.pending_aggregate !== undefined ? notificationAction(notification) : notificationNoAction(notification)">
              <v-list-tile-avatar>
                <!-- see notification build (avatar? icon? -->
                <avatar size="40"
                        :avatar="notification.avatar || notification.icon "
                        :icon="notification.icon || ''"
                        :color="notification.icon ? 'white' : null"
                ></avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{notification.title}}</v-list-tile-title>
                <v-list-tile-sub-title>{{notification.body}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <div id="infinite-loader" v-observe-visibility="e => loaderVisible = e" />
          <div v-if="!noMoreResults" class="icon-wrapper loader">
            <v-progress-circular indeterminate class="primary--text" :size="30"></v-progress-circular>
          </div>
          <div v-if="noMoreResults" class="icon-wrapper loader">
            <p>{{$tf('No more notifications')}} :)</p>
          </div>
        </v-list>
        <div class="no-notifications" v-else>{{$tf('NoNewNotifications')}}</div>
        <div class="enable-notifications" @click="$store.dispatch('notifications/enableDesktop')"
             v-if="!$store.state.notifications.enabledDesktop">
          <v-icon>notifications</v-icon>
          <span>{{$tf('EnableNotifications')}}</span>
        </div>
      </div>

    </v-menu>

    <v-menu offset-y right :close-on-click="true" :close-on-content-click="true">
      <v-tooltip left slot="activator">
        <v-btn icon slot="activator" :aria-label="$tf('Language')">
          <v-icon aria-hidden="true">language</v-icon>
        </v-btn>
        <span>{{$tf('Language')}}</span>
      </v-tooltip>

      <short-lang-menu/>
      <!--<full-lang-menu/>-->
    </v-menu>

    <v-menu offset-y right v-if="isAuthenticated && !$store.getters['session/isScoped']">
      <v-tooltip left slot="activator">
        <v-btn icon v-if="isAuthenticated" slot="activator">
          <avatar size="36" :account="$store.state.session.account" :updated="lastAvatarUpdate"/>
        </v-btn>
        <span>{{fullname}}</span>
      </v-tooltip>

      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <avatar :account="$store.state.session.account"
                    @click="openUploadFileModal"
                    :updated="lastAvatarUpdate"
                    size="80"
                    editable/>
            <div class="identity">
              <div class="name headline">{{fullname}}</div>
              <div class="username">
                {{$store.state.session.account.username}}
              </div>
            </div>
          </v-layout>
          <div class="user-card-actions">
            <v-btn to="/logout">
              <v-icon left>power_settings_new</v-icon>
              {{$tf('LogOut')}}
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-menu>
    <v-tooltip left v-else-if="isPublic">
      <v-btn icon slot="activator" to="/logout" :aria-label="$tf('LogOut')">
        <v-icon aria-hidden="true">power_settings_new</v-icon>
      </v-btn>
      <span>{{$tf('LogOut')}}</span>
    </v-tooltip>
  </div>


</template>

<script>
  import { GetAccountName } from '~/helpers/account'
  import Api from '~/store/idonia-api/api'
  import FullLangMenu from '~/components/header/lang/FullLangMenu.vue'
  import ShortLangMenu from '~/components/header/lang/ShortLangMenu.vue'
  import bus from '~/bus'

  export default {
    name: 'platform-actions',
    components: {
      FullLangMenu,
      ShortLangMenu
    },
    computed: {
      isAuthenticated: function () {
        return this.$store.getters['session/isAuthenticated']
      },
      lastAvatarUpdate () {
        return this.$store.state.session.lastAvatarUpdate || 0
      },
      fullname: function () {
        return GetAccountName(this.$store.state.session.account)
      },
      notifications: function () {
        return this.$store.state.notifications.notifications
      },
      flagAll: function () {
        return this.loaderVisible && !this.busy && this.notificationsList.length > 0
      },
      routeName () {
        return this.$route.name || ''
      },
      isPublic () {
        return this.routeName.startsWith('public-file')
      }
    },
    data () {
      return {
        isFirst: true,
        notificationsList: [],
        loaderVisible: true,
        noMoreResults: false,
        showDiv: true,
        busy: false,
        oldEntrytime: 0,
        isVisible: false,
        contactDialogOpen: false,
        contactDialogLoading: false
      }
    },
    watch: {
      loaderVisible (val) {
        if (val &&
          !this.busy &&
          this.checkInView() &&
          !this.noMoreResults) {
          this.busy = true
          setTimeout(this.loadMoreNotifications, 800)
        }
      },
      busy (val) {
        if (!val &&
        this.loaderVisible &&
        this.checkInView() &&
        !this.noMoreResults) {
          this.busy = true
          setTimeout(this.loadMoreNotifications, 800)
        }
      },
      flagAll (val) {
        if (val && !this.noMoreResults && this.checkInView()) {
          this.busy = true
          setTimeout(this.loadMoreNotifications, 800)
        }
      }
    },
    methods: {
      openContactDialog () {
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('web support'),
          body: require('~/components/common/dialog/types/DialogContactForm.vue').default,
          width: 720,
          persistent: false,
          props: {
            account: this.$store.state.session.account
          }
        })
        bus.$emit('analytics', {
          action: 'open-contact-dialog'
        })
      },
      refreshComponent (isVisible, entry) {
        this.isVisible = isVisible
        if (entry.time - this.oldEntrytime > 1000) {
          if (!isVisible) {
            this.notificationsList = []
            this.$forceUpdate()
            this.noMoreResults = false
            this.oldEntrytime = entry.time
            this.$store.dispatch('notifications/updateNotRead')
          }
        }
        if (isVisible) {
          Promise.all([
            this.$store.dispatch('notifications/clearNotifications'),
            this.$store.dispatch('notifications/clearPage')
          ]).then(() => {
            this.$store.dispatch('notifications/getNotifications').then(() => {
              this.notificationsList = this.$store.getters['notifications/allNotifications']
            })
          })
        }
      },
      notificationAction (notification) {
        this.$store.dispatch('notifications/setNotificationRead', notification.ipn_id)
        if (typeof notification.click === 'function') {
          notification.click.call(this, notification.payload)
        } else {
          this.$router.push(notification.payload.file_url.substr(notification.payload.file_url.indexOf('.com/') + '.com'.length))
        }
      },
      notificationNoAction (notification) {
        this.$store.dispatch('notifications/setNotificationRead', notification.ipn_id)
      },
      openUploadFileModal () {
        this.$store.dispatch('dialog/showDialog', {
          title: 'Select an image',
          body: require('~/components/common/dialog/types/DialogCropAndUploadAvatar.vue').default,
          actions: {
            cancel: {}
          }
        })
      },
      loadMoreNotifications () {
        this.busy = true
        let notifications = []
        this.$store.dispatch('notifications/getNotifications').then(response => {
          this.$store.dispatch('notifications/clearNewNotifications')
          notifications = response.body.results
          if (!notifications || typeof (notifications) === 'undefined' || notifications.length < this.$store.state.notifications.count) {
            this.noMoreResults = true
          }
          setTimeout(() => {
            this.busy = false
          }, 2000)
        })
      },
      vh (v) {
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
        return (v * h) / 100
      },
      checkInView () {
        let lastNotificationInList = document.getElementsByClassName('single-notification')[document.getElementsByClassName('single-notification').length - 1]
        let box = lastNotificationInList ? lastNotificationInList.getBoundingClientRect() : {height: 72}
        if (this.notificationsList.length === 0) {
          return false
        }
        if (this.notificationsListMaxHeight >= box.height * this.notificationsList.length) {
          return true
        } else {
          if (typeof lastNotificationInList === 'undefined') {
            return false
          }
          return box.top < box.height * this.notificationsList.length
        }
      },
      openNotifications () {
        this.$store.dispatch('notifications/clearNewNotifications')
        if (this.$store.state.config.notifications) {
          bus.$emit('analytics', {
            action: 'open-notifications'
          })
        }
      }
    },
    mounted () {
      this.$store.dispatch('notifications/setWebsocket', {socket: Api.websocket()})
      this.$store.dispatch('notifications/clearPage')
      this.notificationsList = this.$store.getters['notifications/allNotifications']
    },
    updated () {
      if (this.isAuthenticated) {
        var noti_list = document.getElementById('notifications-list')
        if (noti_list) {
          this.notificationsListMaxHeight = parseInt(window.getComputedStyle(noti_list).maxHeight)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .icon-wrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    min-width: 180px;
  }
  #infinite-loader {
    width: 5px;
    height: 5px;
    z-index: 1000;
  }
   .notifications-list {
    min-width: 250px;
    background-color: white;
    overflow: auto;
    overflow-x: hidden;
    max-height: 60vh;
    width: 30vw;
  }
  .notifications-list .unread {
    background-color: #DFDFDF;
  }

  .notifications-list .no-notifications {
    font-style: italic;
    padding: 12px;
    text-align: center;
    width: 30vw;
    min-width: 250px;
  }

  .notifications-list .enable-notifications {
    background-color: #e0e0e0;
    padding: 12px;
    text-align: center;
    cursor: pointer;
  }

  .notifications-list .enable-notifications span {
    padding-left: 6px;
  }

  .user-card-actions {
    border-top: 1px solid #ccc;
    background-color: #ddd;
    margin-top: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: right;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .card {
    min-width: 250px;
  }

  .list__tile__avatar {
    margin-right: 15px;
  }

  .identity {
    margin-right: 15px;
    margin-left: auto;
  }

  .identity .name, .identity .username {
    text-align: right;
  }

  .card .container {
    margin: 0;
    padding: 0;
  }

  .card .layout {
    padding: 15px;
  }

  .list__tile__sub-title {
    max-width: 350px;
    text-overflow: ellipsis;
  }
</style>
<style>
  .menu__content{
    margin-top: 25px;
    width: fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/PlatformActions.vue